<div class="table-row-entry entry-wrapper entry-wrapper{{ entryClassByStatus }}">
  <div
    (click)="isClickable && entryClicked.emit(entry)"
    class="entry-name"
    [class.entry-name--clickable]="isClickable"
  >
    <div class="entry-position">{{ entry?.position }}</div>
    <div class="club-image">
      <img
        [src]="
          entry?.squad?.club_image | imageVariant: {width: 100, height: 100, quality: 30}
        "
        [alt]="entry?.squad?.club_code"
        onerror="this.style.display='none'"
      />
    </div>

    <div class="club-name">{{ entry?.squad?.club_name }}</div>
    <div class="entry-trophy" *ngIf="entryPromotion">
      <div>({{ entryPromotion | translate }})</div>
      <img *ngIf="trophyImageUrl" [src]="trophyImageUrl" alt="awans" />
    </div>
  </div>
  <div>
    <ng-container *ngIf="liveMatchesTemplate">
      <ng-container *ngTemplateOutlet="liveMatchesTemplate"></ng-container>
    </ng-container>
  </div>

  <div class="table-row-data" [class.table-row-data--with-form]="hasFormData">
    <span>{{ entry?.matches_played }}</span>
    <span class="desktop-visible">{{ entry?.won }}</span>
    <span class="desktop-visible">{{ entry?.draw }}</span>
    <span class="desktop-visible">{{ entry?.lost }}</span>
    <span>{{ entry?.goals_for }}:{{ entry?.goals_against }}</span>
    <span class="table-row-data-points">{{ entry?.points }}</span>
    <div class="desktop-visible" *ngIf="hasFormData">
      <tisa-season-table-last-five-matches
        [lastFiveMatches]="entry?.last_five_matches"
      ></tisa-season-table-last-five-matches>
    </div>
  </div>
</div>
